<template>
  <div id="paypal-button-container"></div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Paypal',
  props: {
    gatewaySettings: {
      type: Object,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    secret: {
      required: true,
    },
    selectedTickets: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.initPaypal()
  },
  methods: {
    initPaypal() {
      let self = this

      Vue.nextTick(() => {
        paypal
          .Buttons({
            // Set up the transaction
            createOrder: (data, actions) => {
              let formData = new FormData()
              formData.append('secret', self.secret)

              return fetch(
                `/events/${self.event.uuid}/payment-gateway/paypal/order/create`,
                {
                  method: 'post',
                  headers: {
                    'X-CSRF-TOKEN': document.querySelector(
                      'meta[name="csrf-token"]'
                    ).content,
                  },
                  body: formData,
                }
              )
                .then((res) => {
                  return res.json()
                })
                .then((data) => {
                  return data.id
                })
            },

            // Finalize the transaction
            onApprove: (data, actions) => {
              // Set up the data you need to pass to your server

              let formData = new FormData()
              formData.append('orderID', data.orderID)
              formData.append('payerID', data.payerID)
              formData.append(
                'facilitatorAccessToken',
                data.facilitatorAccessToken
              )
              formData.append('paymentSource', data.paymentSource)
              formData.append('secret', self.secret)

              return fetch(
                `/events/${self.event.uuid}/payment-gateway/paypal/order/capture`,
                {
                  method: 'POST',
                  headers: {
                    'X-CSRF-TOKEN': document.querySelector(
                      'meta[name="csrf-token"]'
                    ).content,
                  },
                  body: formData,
                }
              )
                .then((res) => {
                  return res.json()
                })
                .then((data) => {
                  if (data.status == 'COMPLETED') {
                    window.alert('Плащането е успешно!')
                    // self.step = 3;
                    this.$emit('step-change', 3)
                  }
                  return data
                })
            },
          })
          .render('#paypal-button-container')
      })
    },
  },
}
</script>

<style scoped></style>
